<template>
    <div class="parking-view-btns">
        <div class="btn-item  btn-wow-effect-hover" :class="{'active' : parkingListView == 'list'}" @click="changeListView('list')"> 
            <svgIcon name="list-view" class="icon-list"/>
        </div>
        <div class="btn-item  btn-wow-effect-hover" :class="{'active' : parkingListView == 'grid'}" @click="changeListView('grid')">
            <svgIcon name="grid-view" class="icon-grid"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'parking-view-btns',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            parkingListView: 'loadParkingListView',
            // indexPage: 'loadIndexPage',
        }),
        methods: {
            changeListView(data) {
                this.$store.commit('changeParkingListView', data)
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/parking-page/parking-view-btns.scss';
    @import '@/styles/components/parking-page/respond/parking-view-btns-respond.scss';
</style>